// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "@hotwired/turbo-rails"

axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

// Turbo handles navigation AND form submission natively (data-turbo-method /
// data-turbo-confirm on button_to/link_to). Controllers render validation
// failures with :unprocessable_entity (422) so Turbo re-renders the form.
require("../image_preview")
require("../avatar_preview")
require("../push")
require("../daily_bonus")

require("./items_list")
require("./users_list")
require("./groups_list")
require("./avatar_list")
require("./user_show")
require("./message_compose")
require("./bulk_select")
require("./report_dialog")
require("./admin_search")
require("./item_wizard")
require("./main")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
